
	export const COLORS = [
		"blue",     // 0
		"green", 	// 1
		"yellow", 	// 2
		"orange", 	// 3
		"red", 		// 4
		"purple", 	// 5
		"brown", 	// 6
		"grey", 	// 7
		"white", 	// 8
		"black",	// 9
		"cyan",		// 10
		"pink",		// 11
	]




function toHex(c) {
	let hex = c.toString(16);
	return hex.length === 1 ? "0" + hex : hex;
}


export function toRGB(hex) {
	return {
		r: Number(`0x${hex.substring(1, 3)}`),
		g: Number(`0x${hex.substring(3, 5)}`),
		b: Number(`0x${hex.substring(5, 7)}`),
	}
}


export function	getRandomColorElement() {
		let label = Math.trunc(Math.random() * 12)
		let hexColor = createRandomColor(label)
		let elem = {
			hexColor: hexColor,
			label: label,
		}
		return elem
	}

/*
function createRandomColor(r) {
	let hex = "#000000";
	switch (r) {
		case 0:	// BLUE
			hex = createColor(0, 63, 0, 127, 159, 255, -1, false); break;
			//rgb = Utils.createColor(127, 159, 159, 191, 191, 255, -1, false); break;
		case 1: // GREEN
			hex = createColor(0, 63,  159, 255, 0, 127, -1, false); break;
		case 2:	// YELLOW
			hex = createColor(223, 255, 223, 255, 0, 159, -1, false); break;
		case 3:	// ORANGE
			hex = createColor(223, 255, 128, 191, 0, 95, -1, false); break;
		case 4: // RED
			hex = createColor(159, 255, 0, 31, 0, 31, -1, false); break;
		case 5:	// PURPLE
			hex = createColor(127, 159, 0, 191, 223, 255, 1, false); break;
		case 6:	// BROWN
			hex = createColor(159, 191, 95, 127, 0, 63, -1, false); break;
		case 7:	// GREY
			hex = createColor(63, 191, 63, 191, 63, 191, -1, true); break;
		case 8:	// WHITE
			hex = createColor(223, 250, 223, 250, 223, 250, -1, true); break;
		case 9: // BLACK
			hex = createColor(0, 31, 0, 31, 0, 31, -1, true); break;		
		default:
			hex = "#000000";
	}
	return hex;
}


function createColor(rmin, rmax, gmin, gmax, bmin, bmax, lowest, almostEqual) {
	let d = rand();
	let c = 0;

	// RED
	let r = rmin + Math.trunc(d * (rmax - rmin));
	r = Math.max(r, 0);
	
	if (!almostEqual)
		d = rand();
	else
		c = Math.trunc((rand() * 2 - 1) * 5);

	// GREEN
	let g = gmin + Math.trunc(d * (gmax - gmin)) + c;
	g = Math.max(g, 0);

	if (!almostEqual)
		d = rand();
	else
		c = Math.trunc((rand() * 2 - 1) * 5);

	// BLUE
	let b = bmin + Math.trunc(d * (bmax - bmin)) + c;
	b = Math.max(b, 0);

	if (lowest === 0) {
		if (r > g) r = g - 20;
		if (r > b) r = b - 20;
	}
	else if (lowest === 1) {
		if (g > r) g = r - 20;
		if (g > b) g = b - 20;
	}
	else if (lowest === 2) {
		if (b > r) b = r - 20;
		if (b > g) b = g - 20;
	}
	return "#" + toHex(r) + toHex(g) + toHex(b);
}
*/


	function rand(upper) {
		return Math.trunc(Math.random() * upper)
	}
/*
	function createBlue() {
		let b = rand(106) + 150;
		let diff = (255 - b) + Math.trunc(((b - 99) / 4));
		let r = rand(b - diff);
		let g = r + rand(25) + 20; 
		return [r, g, b];
	}
*/

	function createBlue() {
		if (Math.random() > 0.5) {
			let b = rand(106) + 150;
			let diff = (255 - b) + ((b - 69) / 2);
			let r = rand(b - diff);
			let g = r + 50 + rand(10); 
			return [r, g, b];
		}
		let b = rand(26) + 230;
		let r = 20 + rand(50);
		let g = r + 80 + rand(20); 
		return [r, g, b];
	}

	function createRed() {
		let r = rand(106) + 150;
		let g = rand(r - 149);
		let b = g + Math.max(0, rand(20) - 40);
		return [r, g, b];
	}

	function createGreen() {
		let g = rand(106) + 150;
		let diff = (255 - g) + Math.trunc(((g - 99) / 4));
		let r = rand(g - diff);
		let b = Math.max(0, r + rand(50) - 100); 
		return [r, g, b];
	}

	function createYellow() {
		let r = rand(36) + 220;
		let g = (r + rand(10) - 20) % 256;
		let b = rand(150);
		return [r, g, b];
	}

	function createOrange() {
		let r = rand(36) + 220;
		let g = rand(90) + 100;
		let b = rand(90);
		return [r, g, b];
	}	

	function createBrown() {
		let r = rand(50) + 150;
		let g = r - 50 + rand(10) - 20;
		let b = g - 50 + rand(10) - 20;
		return [r, g, b];
	}	

	function createPurple() {
		let b = rand(56) + 200;
		let r = rand(60) + 130;
		let g = rand(50) + r - 50;
		return [r, g, b];
	}	

	function createPink() {
		let r = rand(36) + 220;
		let b = r - rand(25) - 50;
		let g = rand(150);
		return [r, g, b];
	}	

	function createCyan() {
		let b = rand(106) + 150;
		let g = b - 10 - rand(10);
		let r = rand(b - 50);
		return [r, g, b];
	}	

	function createGrey() {
		let r = rand(130) + 90;
		let g = (r + rand(10) - 5) % 256;
		let b = (r + rand(10) - 5) % 256;
		return [r, g, b];
	}	

	function createWhite() {
		let r = rand(16) + 240;
		let g = Math.min(255, r + rand(6) - 3);
		let b = Math.min(255, r + rand(6) - 3);
		return [r, g, b];
	}	

	function createBlack() {
		let r = rand(70);
		let g = Math.max(0, r + rand(6) - 3);
		let b = Math.max(0, r + rand(6) - 3);
		return [r, g, b];
	}	


	function createRandomColor(r) {
		let rgb = [0, 0, 0]
		switch (r) {
			case 0:	rgb = createBlue(); break;
			case 1: rgb = createGreen(); break;
			case 2:	rgb = createYellow(); break;
			case 3:	rgb = createOrange(); break;
			case 4: rgb = createRed(); break;
			case 5:	rgb = createPurple(); break;
			case 6:	rgb = createBrown(); break;
			case 7:	rgb = createGrey(); break;
			case 8:	rgb = createWhite(); break;
			case 9: rgb = createBlack(); break;		
			case 10: rgb = createCyan(); break;		
			case 11: rgb = createPink(); break;		
			default:
				rgb = [0, 0, 0];
		}
		let hex = "#" + toHex(rgb[0]) + toHex(rgb[1]) + toHex(rgb[2])
		//console.log("color ", r, COLORS[r], rgb, hex)
		return hex;
	}		